enum OrderStatesEnum {
    PRELIMINARY = 1,
    SUBMITTED = 2,
    IN_REVIEW = 3,
    SCHEDULED = 4,
    CONFIRMED = 5,
    READY_FOR_PICKUP = 6,
    DELAYED = 7,
    SHIPPED = 8,
    COMPLETED = 9,
    VENDOR_APPROVAL_PAYMENT,
    ACCOUNTING,
    PAYMENT_RECEIVED_ORDER_BEING_PACKED,
    PACKING_COMPLETED_AWAITING_SHIPPING_INFO,
    DEPOSIT_RECEIVED_ORDER_PACKING,
    PACKING_COMPLETED_AWAITING_PAYMENT_BALANCE_TO_SHIP,
    PARTIALLY_SHIPPED,
    PROCESSED,
    PRINTED,
    MOUNTED,
    IN_PROGRESS_PACKING,
    READY_TO_SHIP,
    DELIVERED,
    CANCELLED,
    OPEN,
    CLOSED,
    LAMINATED,
    IN_QUEUE,
    AWAITING_REVIEW,
    UNDER_REVIEW,
    APPROVED,
    FINISHING,
    PICKED_UP,
    SUBMITTED_TO_PRODUCTION,
    WELD_COMPLETED,
    INITIAL_QC_COMPLETED,
    PAINT_COMPLETED,
    FINAL_QC_COMPLETED,
    PENDING,
    ACTIVE,
    READY_FOR_DELIVERY,
    IN_DESIGN,
    SENT_TO_PHARMACY,
    AWAITING_FINAL_ACCOUNT_APPROVAL,
    READY_FOR_PICK,
    PRE_PRESS,
    READY_TO_PRINT,
    PRINTING,
    MATERIAL_CUTTING,
    SEWING,
    NEW,
    WAREHOUSE,
    BILLED,
    VENDOR_SOURCE_APPROVAL_AWAITING_PAYMENT,
    PARTS_ORDERED,
    PARTIALLY_DELIVERED,
    PARTIALLY_PICKED_UP,
}

export default OrderStatesEnum;
